<template>
  <div class="page">
    <div class="page-header">
      <div class="header-text">
        <h1 v-html="focus.cartouche ? focus.cartouche.titre : ''"></h1>
        <p v-html="focus.cartouche ? focus.cartouche.texte : ''"></p>
      </div>
      <img class="header-img" src="../../assets/images/courtage/visuel@3x.webp" />
    </div>
    <div class="page-content">
      <div>
        <h3 v-html="focus.paragraphe1 ? focus.paragraphe1.titre : ''"></h3>
        <p v-html="focus.paragraphe1 ? focus.paragraphe1.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe1 ? focus.paragraphe1.image : ''">
        </div>
        <h3 v-html="focus.paragraphe2 ? focus.paragraphe2.titre : ''"></h3>
        <p v-html="focus.paragraphe2 ? focus.paragraphe2.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe2 ? focus.paragraphe2.image : ''">
        </div>
        <h3 v-html="focus.paragraphe3 ? focus.paragraphe3.titre : ''"></h3>
        <p v-html="focus.paragraphe3 ? focus.paragraphe3.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe3 ? focus.paragraphe3.image : ''">
        </div>
        <h3 v-html="focus.paragraphe4 ? focus.paragraphe4.titre : ''"></h3>
        <p v-html="focus.paragraphe4 ? focus.paragraphe4.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe4 ? focus.paragraphe4.image : ''">
        </div>
        <h3 v-html="focus.paragraphe5 ? focus.paragraphe5.titre : ''"></h3>
        <p v-html="focus.paragraphe5 ? focus.paragraphe5.texte : ''"></p>
        <div class="img-wrapper">
          <img :src="focus.paragraphe5 ? focus.paragraphe5.image : ''">
        </div>
      </div>
    </div>
    <site-link siteName="Courtage"></site-link>
  </div>
</template>

<script>
import { getFocus } from '../../mixins/getFocus'
import SiteLink from '../Components/SiteLink.vue'

export default {
  name: 'Financement',
  mixins: [getFocus],
  components: {
    SiteLink
  },
  data() {
    return {
      focus: {}
    }
  },
  async beforeMount() {
    await this.getFocus('cg', 'Assurances & Prévoyance')
      .then(res => {
        this.focus = res
      })
  }
}
</script>
<style lang="scss" scoped>
h3 {
  margin-top: 24px;
}

.img-wrapper {
  img {
    max-width: 1000px !important;
  }
}
</style>
